<template>
  <Teleport defer :to="`[data-shell='${BOTTOM_STACK_TARGETS[layer]}']`">
    <Transition v-bind="stackItemTransition">
      <slot />
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { BOTTOM_STACK_TARGETS, stackItemTransition } from '@dashboard/composables/useBottomStack'
import type { BottomStackLayer } from '@dashboard/composables/useBottomStack'

// Places a page-owned bar or status notification in the bottom stack. The slot
// renders one element (usually behind a v-if) so it animates like other items.
defineProps<{ layer: BottomStackLayer }>()
</script>
